function Edit() {
    return (
        <input type="text" />
    )
}

export default Edit;